import { useState } from "react";
import { useAdminAuth } from "../context/AdminAuthContext";
import adminApi from "../lib/adminApi";
import { toast } from "sonner";
import { Lock, ShieldCheck } from "@phosphor-icons/react";

export default function AdminSettings() {
  const { admin, refresh } = useAdminAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    if (next.length < 8) {
      toast.error("Mot de passe trop court (min. 8 caractères)");
      return;
    }
    setLoading(true);
    try {
      await adminApi.post("/password/change", { current_password: current, new_password: next });
      toast.success("Mot de passe mis à jour");
      setCurrent("");
      setNext("");
      setConfirm("");
      await refresh();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-settings-page">
      <div className="label-mono">§ 05 · Compte &amp; sécurité</div>
      <h1 className="font-serif text-4xl sm:text-5xl font-medium mt-2">Compte administrateur</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-10">
        <section className="border border-black p-6 bg-[var(--paper)]">
          <h2 className="font-serif text-2xl font-medium flex items-center gap-2">
            <ShieldCheck size={22} className="text-[var(--signal)]" /> Identité
          </h2>
          <div className="mt-4 space-y-3 text-sm">
            <div>
              <div className="label-mono mb-1">Email admin</div>
              <div className="font-mono">{admin?.email}</div>
            </div>
            <div>
              <div className="label-mono mb-1">Email de récupération</div>
              <div className="font-mono">{admin?.recovery_email}</div>
            </div>
            <div>
              <div className="label-mono mb-1">Dernière connexion</div>
              <div className="font-mono text-xs">{admin?.dernier_login || "—"}</div>
            </div>
            <div>
              <div className="label-mono mb-1">Statut mot de passe</div>
              <div className="font-mono text-xs">
                {admin?.must_change_password ? (
                  <span className="text-[var(--signal)]">Initial · à changer</span>
                ) : (
                  <span>Personnalisé ✓</span>
                )}
              </div>
            </div>
          </div>
        </section>

        <form onSubmit={submit} className="border border-black p-6 bg-[var(--paper)]" data-testid="admin-pwd-form">
          <h2 className="font-serif text-2xl font-medium flex items-center gap-2">
            <Lock size={22} className="text-[var(--signal)]" /> Changer le mot de passe
          </h2>
          <div className="mt-4 space-y-3">
            <label className="block">
              <div className="label-mono mb-2">Mot de passe actuel</div>
              <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className="w-full border border-black px-4 py-3" data-testid="admin-pwd-current" />
            </label>
            <label className="block">
              <div className="label-mono mb-2">Nouveau mot de passe (min. 8)</div>
              <input type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className="w-full border border-black px-4 py-3" data-testid="admin-pwd-new" />
            </label>
            <label className="block">
              <div className="label-mono mb-2">Confirmation</div>
              <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full border border-black px-4 py-3" data-testid="admin-pwd-confirm" />
            </label>
          </div>
          <button type="submit" disabled={loading} className="mt-6 bg-[var(--signal)] hover:bg-[var(--signal-hover)] text-[var(--paper)] px-6 py-3 label-mono disabled:opacity-60" data-testid="admin-pwd-submit">
            {loading ? "Mise à jour..." : "Mettre à jour"}
          </button>
        </form>
      </div>
    </div>
  );
}
